import { render, staticRenderFns } from "./deliveryByOrderid.vue?vue&type=template&id=4c0360aa&scoped=true&"
import script from "./deliveryByOrderid.vue?vue&type=script&lang=js&"
export * from "./deliveryByOrderid.vue?vue&type=script&lang=js&"
import style0 from "./deliveryByOrderid.vue?vue&type=style&index=0&id=4c0360aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0360aa",
  null
  
)

export default component.exports